import React, { useEffect, useContext } from 'react';

import AnalyticsContext from 'context/analytics';
import EventService from 'services/EventService';
import { TrackManagementProps } from 'shared/interfaces/marketing/event-marketing-props.interface';

let ga4Code: string;

const AnalyticsManagement: React.FC<TrackManagementProps> = ({ data, eventId }) => {
	const { state, setState } = useContext(AnalyticsContext);

	useEffect(() => () => {
		//@ts-ignore
		window[`ga-disable-${ga4Code}`] = true;
	}, [])

	useEffect(() => {
		if (!data) return;
		const index = data?.findIndex((el: any) => el.type === 'ANALYTICS');

		if (index !== -1) {
			setAnalyticsValues(data, eventId as string);

			if (data[index].status === 'ENABLED' && data[index].options.code) {
				ga4Code = data[index].options.code as string;
				initAnalytics(data[index].options.code!);
			}
		}
	}, [data]);

	useEffect(() => {
		if (state.active && state.code && state.name === eventId) {
			// @ts-ignore
			window[`ga-disable-${state.code}`] = false;
		}
	}, [eventId]);

	const setAnalyticsValues = (analytics: any, name: string) => {
		setState({
			active: (analytics.status === 'ENABLED'),
			code: analytics.options?.code,
			name: name,
		})
	}

	const initAnalytics = (code: string) => {
		window.gtag('config', code);
	}

	return (<></>);
}

export default AnalyticsManagement;
